import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Section } from '../components/Section';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      const response = await fetch('https://formspree.io/f/myzrjnql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          _replyto: formData.email,
          _subject: `Contact from ${formData.name}`
        })
      });
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-213">
      <Navbar data-id="element-214" />
      <main className="flex-grow" data-id="element-215">
        {/* Hero Section */}
        <Section className="pt-32 md:pt-48 pb-8 md:pb-12" data-id="element-216">
          <div className="max-w-3xl mx-auto text-center" data-id="element-217">
            <h1 className="font-poppins font-normal text-3xl md:text-5xl text-black leading-tight mb-6" data-id="element-218">
              What's hidden matters.
            </h1>
            <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-219">
              If something's catching on, or getting stuck, let's talk about it.
            </p>
          </div>
        </Section>
        {/* Contact Form Section */}
        <Section className="py-8 md:py-12" data-id="element-220">
          <div className="max-w-2xl mx-auto" data-id="element-221">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-222">
              {/* Name Field */}
              <div data-id="element-223">
                <label htmlFor="name" className="block font-inter text-sm font-medium text-black mb-2" data-id="element-224">
                  Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-lightgray rounded-md font-inter text-base text-black focus:outline-none focus:ring-2 focus:ring-lime focus:border-transparent" data-id="element-225" />
              </div>
              {/* Email Field */}
              <div data-id="element-226">
                <label htmlFor="email" className="block font-inter text-sm font-medium text-black mb-2" data-id="element-227">
                  Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-lightgray rounded-md font-inter text-base text-black focus:outline-none focus:ring-2 focus:ring-lime focus:border-transparent" data-id="element-228" />
              </div>
              {/* Message Field */}
              <div data-id="element-229">
                <label htmlFor="message" className="block font-inter text-sm font-medium text-black mb-2" data-id="element-230">
                  Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-3 border border-lightgray rounded-md font-inter text-base text-black focus:outline-none focus:ring-2 focus:ring-lime focus:border-transparent resize-none" data-id="element-231" />
              </div>

              {/* Success Message */}
              {submitStatus === 'success' && <div className="p-4 bg-lime bg-opacity-20 border border-lime rounded-md" data-id="element-232">
                  <p className="font-inter text-base text-black" data-id="element-233">
                    Thank you! Your message has been sent successfully. We'll
                    get back to you soon.
                  </p>
                </div>}

              {/* Error Message */}
              {submitStatus === 'error' && <div className="p-4 bg-coral bg-opacity-20 border border-coral rounded-md" data-id="element-234">
                  <p className="font-inter text-base text-black" data-id="element-235">
                    Sorry, something went wrong. Please try again or email us
                    directly at chat@hiddenmatter.ai
                  </p>
                </div>}

              {/* Submit Button */}
              <button type="submit" disabled={isSubmitting} className="w-full bg-lime text-black font-poppins font-normal py-3 px-6 rounded-md transition-all duration-300 hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-236">
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
            {/* Direct Contact */}
            <div className="mt-12 text-center" data-id="element-237">
              <p className="font-inter text-base text-black mb-2" data-id="element-238">
                Or reach us directly at
              </p>
              <a href="mailto:chat@hiddenmatter.ai" className="font-inter text-base text-black hover:text-lime transition-colors underline" data-id="element-239">
                chat@hiddenmatter.ai
              </a>
            </div>
          </div>
        </Section>
      </main>
      <Footer data-id="element-240" />
    </div>;
}